import React, { useState } from 'react';
import './trackInfo.css'; // Optional: You can style your modal in this CSS file
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';

const AddTrackModal = ({ isOpen, onClose, onSubmit,index}) => {
  const [inputText, setInputText] = useState('');

  const handleInputChange = (e) => {
    setInputText(e.target.value);
  };

  const handleSubmit = () => {
    onSubmit(inputText,index);
    setInputText(''); // Clear input after submission (if desired)
    onClose(); // Close the modal after submission (if desired)
  };

  if (!isOpen) return null;

  return (<>
    <Modal show={true} onHide={onClose} size='lg'>
        <Modal.Header closeButton>
            <Modal.Title> {"Enter tracking url"}
            </Modal.Title>
        </Modal.Header>
        <Modal.Body >
  
        <input
          type="text"
          value={inputText}
          onChange={handleInputChange}
          placeholder="Enter text..."
        />
        {/* <button onClick={handleSubmit}>Submit</button> */}
        </Modal.Body>
        <Modal.Footer>
            <div className='flex-row justify'>
                <div className='flex-row' style={{display:'contents'}}>
                    <Button variant="secondary" onClick={onClose} style={{ marginRight: 10 }}>
                        Close
                    </Button>

                    <Button variant="secondary" onClick={handleSubmit} style={{ marginRight: 10 }}>
                    Submit
                    </Button>

                   
                </div>
            </div>
        </Modal.Footer>
    </Modal>
</>)

};

export default AddTrackModal;
